/**
 * Wire a host `ResourceProvider` into the resource pipeline: a `FileEventBus` over the
 * provider, a `ResourceLoader` over the bus, then `loader.setProvider(provider)`. The
 * order is an invariant, owned here so every host builds the same pipeline. A host
 * that can start a job worker passes `createWorker` (ADR-0042).
 */
import { FileEventBus } from './FileEventBus';
import { ResourceLoader } from './ResourceLoader';
export function createResourcePipeline(provider, options = {}) {
    const bus = new FileEventBus(provider);
    const loader = new ResourceLoader(bus, options);
    loader.setProvider(provider);
    return { provider, loader };
}
//# sourceMappingURL=createResourcePipeline.js.map